import type { APICallerFactory } from '@phi/frontend/api';

export type StripeAPI = ReturnType<typeof stripe_api_provider>;

export const stripe_api_provider = (api: APICallerFactory) => ({
    get_customer_portal_url: api('get_customer_portal_url'),
    create_customer_session: api('create_customer_session'),
});
